<template>
    <div class="container"> 
        <div class="row">
            <div class="col-md-12">
                <p class="report-title">Sesiones por terapeuta y tipo</p>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-md-12">
                                <p style="font-weight: bold; font-size:20px"> Filtros </p>
                            </div>
                            <div class="col-md-3" style="padding-top:14px;">
                                <label for="initialDate">Fecha inicial</label>
                                <input type="date" class="form-control" id="initialDate" v-model="dates.initial"> 
                            </div>
                            <div class="col-md-3" style="padding-top:14px;">
                                <label for="finalDate">Fecha final</label>
                                <input type="date" class="form-control" id="finalDate" v-model="dates.final"> 
                            </div>
                            <div class="col-md-3">
                                <br> <br>
                                <button class="btn btn-fill btn-success" @click="getSessions()" style="border-radius:7px;">
                                    Buscar información
                                    <i class="fa fa-arrow-right"></i>
                                </button>
                            </div>
                        </div> 
                    </div>
                    <div class="card-content" v-if="data != []">
                        <div class="card-especialidad" v-for="(terapeutas, rol) in data">
                            <div class="row">
                                <div class="col-md-12">
                                    <br>
                                    <strong>{{especialidades[rol]}}</strong>
                                    <ul style="padding-top:10px;">
                                        <li>
                                            Total domicilio: {{calcularTotalesPorRol(terapeutas).Domicilio}}
                                        </li>
                                        <li>
                                            Total sede: {{calcularTotalesPorRol(terapeutas).Sede}}
                                        </li>
                                        <li>
                                            Total virtual: {{calcularTotalesPorRol(terapeutas).Virtual}}    
                                        </li>
                                    </ul>
                                    <hr>
                                </div>
                                <div class="col-md-12">
                                    <table class="el-table el-table-sm table-condensed">
                                        <thead>
                                            <tr>
                                                <th width="20%">Terapeuta</th>
                                                <th>Sesiones en sede</th>
                                                <th>Sesiones Domicilio</th>
                                                <th>Sesiones Virtuales</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(terapeuta, index) in terapeutas">
                                                <td>{{terapeuta.nombres}}  {{terapeuta.apellidos}}</td>
                                                <td>{{terapeuta.Sede}}</td>
                                                <td>{{terapeuta.Domicilio}}</td>
                                                <td>{{terapeuta.Virtual}}</td>
                                                 <td>{{ parseInt(terapeuta.Virtual) + parseInt(terapeuta.Domicilio) + parseInt(terapeuta.Sede)}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import crearAlerta from "../../global-services/crearAlerta";
import axiosInstance from "src/global-services/axiosInstance";

export default {
    name: 'SesionesTerapeutas',
    data() {
        return {
            sesiones: [],
            dates: {
                initial: '',
                final: ''
            },
            data: [],
            especialidades: [
                'N/A',
                'N/A',
                'Fisioterapia',
                'Fonoaudiologia',
                'Terapia ocupacional',
                'Educación especial',
                'Psicologia'
            ] 
        }
    },
    methods: {
        getSessions: async function(){
            try{
                this.$modal.show('carga');
                const response = await axiosInstance.get(
                    `api/get-sessions-dynamic-table/${this.dates.initial}/${this.dates.final}`
                );

                this.data = response.data.data;
            }catch(error){
                crearAlerta('error', error.response.data.message);
            }finally{
                this.$modal.hide('carga');
            }
        },
        calcularTotalesPorRol : function(listaTerapeutas) {
            return listaTerapeutas.reduce(
                (totalesPorRol, terapeuta) => {
                    totalesPorRol.Domicilio += Number(terapeuta.Domicilio);
                    totalesPorRol.Sede += Number(terapeuta.Sede);
                    totalesPorRol.Virtual += Number(terapeuta.Virtual);
                    return totalesPorRol;
                },
                { Domicilio: 0, Sede: 0, Virtual: 0 }
            );
        }
    },
    mounted() {
    }
}
</script>
<style scoped>
.report-title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Reportes/sesionesTerapeutas.vue